module.exports = __webpack_public_path__ + "static/media/similar-0.73c47c8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/similar-0.jpg
// module id = 551
// module chunks = 0